import React from "react";
import { useEffect, useState } from "react";
import { isStatusDto, StatusDto } from "../../../../../enums/Domain/Status";
import Pill from "../../../Pill";
import { displayDateTime, isValidIsoDateString } from "../../../../../helpers/DateHelper";

interface ISidePanelInfoSmall {
    descriptor?: string | undefined;
    values: Array<{ label: string | React.ReactNode; value: any, classname?: string }>;
    canRender?: boolean;
}

// Emulate two versions of this for operator and customer access display
export default function SidePanelInfo({ descriptor, values, canRender = true }: ISidePanelInfoSmall) {
    const [_values, setValues] = useState<Array<{ label: string | React.ReactNode; value: any, classname?: string }>>()

    function renderValue(value: any, classname?: string) {
        if (isStatusDto(value)) {
            return <Pill statusDto={value} />
        }

        if (isValidIsoDateString(value)) {
            return <p className={`small small--2 textWrap ${classname}`}>{displayDateTime(value)}</p>;
        }

        if (typeof value === "string") {
            return <p className={`small small--2 textWrap ${classname}`}>{value}</p>;
        }

        if (React.isValidElement(value)) {
            return value;
        }

        return <p className={`small small--2 textWrap ${classname}`}>{String(value)}</p>;
    }

    useEffect(() => {
        const filteredValues = values.filter(x => x.value !== undefined && x.value !== null && x.value !== "")
        setValues(filteredValues)
    }, [values])

    return (<>
        {!canRender &&
            <div className="side-panel__info-box margin__top--s">
                <div className={`display--flex alignItems--center flex__direction--column gap--s`}>
                    <div className={`form__wrapper form__wrapper`}>
                        <div className="loaders loaders__panel form__inline-loader"></div>
                    </div>
                </div>
            </div>
        }
        {canRender && _values && _values.length > 0 &&
            <div className="side-panel__info-box margin__top--s">
                {descriptor && <p className="small margin__bottom--xs">{descriptor}</p>}
                <div className="side-panel__info">
                    {_values.map(x => <div className="" key={typeof x.label === 'string' ? x.label : undefined}>
                        {typeof x.label === 'string' ? <p className="xsmall">{x.label}</p> : <div className="xsmall">{x.label}</div>}
                        {renderValue(x.value, x.classname)}
                    </div>
                    )}
                </div>
            </div>
        }
    </>
    )
}